import { render } from "./HistorialProductosVistos.vue?vue&type=template&id=7bbb5b08"
import script from "./HistorialProductosVistos.js?vue&type=script&lang=js&external"
export * from "./HistorialProductosVistos.js?vue&type=script&lang=js&external"

import "./HistorialProductosVistos.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__